<script>
  import { format } from 'svelte-i18n';
  import { Input } from '@sveltestrap/sveltestrap';

  import { SectionItem } from '@client/components/section';

  export let change = '';
  export let flags = '';
  export let regexp = '';
</script>

<SectionItem
  label={$format('label.REGULAR_EXPRESSION')}
  tooltip={$format('label.TOOLTIP.REGULAR_EXPRESSION')}
  description={$format('label.DESCRIPTION.REGULAR_EXPRESSION')}
>
  <div class="regexp-field">
    <Input type="text" bind:value={regexp} placeholder={$format('label.REGULAR_EXPRESSION')} data-testid="regexp" />
    <Input type="text" bind:value={flags} placeholder={$format('label.FLAGS')} data-testid="flags" />
    <Input type="text" bind:value={change} placeholder={$format('label.REPLACEMENT')} data-testid="change" />
  </div>
</SectionItem>

<style lang="scss" src="./find-replace.scss"></style>
